import { TextTile, FormattedTextTile } from '@augloop/types-text';
import { formatedTextTileDeltaBuilderHandler, textTileDeltaBuilderHandler } from './delta-builder-handlers';
export class DeltaBuilder {
    constructor() {
        this.deltaBuilderHandlers = new Map();
        this.registerDeltaBuilderHandler(TextTile.getTypeName(), textTileDeltaBuilderHandler);
        this.registerDeltaBuilderHandler(FormattedTextTile.getTypeName(), formatedTextTileDeltaBuilderHandler);
    }
    registerDeltaBuilderHandler(deltaType, handler) {
        this.deltaBuilderHandlers.set(deltaType, handler);
    }
    executeDeltaBuilderHandler(deltaType, oldTile, newTile) {
        const handler = this.deltaBuilderHandlers.get(deltaType);
        if (handler) {
            return handler(oldTile, newTile);
        }
        return [];
    }
}
//# sourceMappingURL=delta-builder.js.map